<template>
  <div class="page-student-gains">
    <div class="page-student-gains-banner">
      <ym-banner v-if="banner.length > 0"
                 class="page-student-gains-banner-content"
                 :banner="banner"
                 :options="bannerOptions"
                 :record-name="recordName"
                 :width="670"
                 :height="388"
                 :shadow="false"
                 @click="handleClickBanner"
      />
    </div>

    <list v-if="loaded"
          :list="list"
          :start="start"
    />
  </div>
</template>

<script>
  import { getStudentGainsIndex } from '@/services/student-gains';
  import Banner from '@/components/Banner';
  import List from '@/pages/StudentGains/components/StudentGainsExplore';

  export default {
    name: 'PageStudentGains',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      'ym-banner': Banner,
      List,
    },
    data() {
      return {
        loaded: false,
        banner: [],
        bannerOptions: {
          slidesPerView: 1,
          spaceBetween: 20,
        },

        list: [],
        start: 0,
        allLoad: false,

        recordName: 'STUDENT_GAINS_BANNER',
        render: {
          pageTitle: '',
        },
      };
    },
    methods: {
      async getStudentGainsIndex() {
        this.loaded = false;

        const data = await getStudentGainsIndex();
        this.banner = data.banner;

        if (data.list.length === 0) {
          this.allLoad = true;
        }

        this.list = data.list;
        this.start = data.start;

        this.render = data.render;

        this.loaded = true;
      },
      handleClickBanner(item) {
        this.$router.push(item.url);
      },
    },
    created() {
      this.getStudentGainsIndex();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-student-gains {
    background: @color-white;

    &-banner {
      padding: @size-base @size-medium;

      &-content {
        padding: 0;
        margin: 0;
      }
    }
  }
</style>
